module.exports = __webpack_public_path__ + "static/media/YM16_2.a59946e4.jpg";